import { BACKEND_HEALTH_CHECK_URL } from '@config/const';
import { createSlice } from '@reduxjs/toolkit';
import {
  createApi,
  fetchBaseQuery,
  retry,
} from '@reduxjs/toolkit/dist/query/react';

const staggeredBaseQuery = retry(fetchBaseQuery(), {
  maxRetries: 10,
});

export const systemApi = createApi({
  reducerPath: 'systemApi',
  baseQuery: staggeredBaseQuery,
  endpoints: (builder) => ({
    checkBackendHealth: builder.query({
      query: () => ({ url: BACKEND_HEALTH_CHECK_URL }),
    }),
  }),
});

const initialState = {
  isAvailable: true,
};

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setUnavailable: (state) => {
      state.isAvailable = false;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      systemApi.endpoints.checkBackendHealth.matchFulfilled,
      (state) => {
        state.isAvailable = true;
        document.title = 'didXL';
      }
    );
  },
});

export const { setUnavailable } = systemSlice.actions;
export const { reducer } = systemSlice;
